<template>
    <div>
        <le-search-form @reset="handlerRest" @search="handlerSearch" :canPackUp="true" id="leSearch">
            <le-input label="订单编号" v-model="pageParam.params.orderSn" />
            <le-date-range 
                label="充值时间" 
                :minDate.sync="pageParam.params.startTime" 
                :maxDate.sync="pageParam.params.endTime" 
                valueFormat="yyyy-MM-dd HH:mm:ss" 
                :defaultTime="['00:00:00','23:59:59']" />
        </le-search-form>
        <le-pagview ref="cardRechargePage" @setData="setTableData" :pageParam="pageParam" :pagerCount="5" :isFixed="true" :tableRef="$refs.cardRechargeList">
            <el-table ref="cardRechargeList" :data="tableData" :highlight-current-row="true" v-sticky="{ top: 0, parent:'.el-card__body' }" style="width: 100%">
                <el-table-column prop="" label="订单编号" min-width="120">
                    <template slot-scope="{ row }">
                        <span>{{ row.orderSn || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="实付金额" min-width="120">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.payAmount) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="线上退款金额" min-width="120">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.refundAmount) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="myOrderNum" label="支付渠道" min-width="120">
                    <template slot-scope="{ row }">
                        <span>{{ util.initDic(row.payChannel, 'payChannel') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="myOrderNum" label="充值状态" min-width="120">
                    <template slot-scope="{ row }">
                        <span>{{ util.initDic(row.orderStatus, 'orderStatus') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="payeeCompanyName" label="充值时间" min-width="120">
                    <template slot-scope="{ row }">
                        <span>{{ row.payTime || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="payeeCompanyName" label="操作人" min-width="120">
                    <template slot-scope="{ row }">
                        <span>{{ row.operateName || '-' }} {{ row.operatePhone || '-' }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="name" label="操作" width="75" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                            <img src="../../assets/icon/option-edit.png" class="a-wh-16" @click="handleEdit(scope.row)" />
                        </el-tooltip>
                    </template>
                </el-table-column> -->
            </el-table>
            <template slot="footerContent" slot-scope="scope" >
                <div class="a-flex-rfsc">
                    <div class="a-flex-rfsc">
                        <span class="a-fs-12 a-c-normal">剩余总额：</span>
                        <span class="a-fs-16 a-c-master a-fw-b">￥{{util.numFormat(cardBalance)}}</span>
                    </div>
                </div>
            </template>
        </le-pagview>
    </div>
</template>

<script>
    import util from "@/utils/util.js";
    export default {
        data () {
            return {
                tableData: [],
                util: util,
                pageParam: {
                    url: this.$Config.apiUrl.userOrCardRechargePage,
                    method: "post",
                    params: {
                        "balanceId": this.id,
                        "endTime": "",
                        "orderSn": "",
                        "payType": "44",
                        "startTime": "",
                        "userId": this.userId
                    },
                    freshCtrl: 1,
                },
            }
        },
        props: ['id', 'userId', 'cardBalance'],
        created () {
        },
        methods: {
            setTableData(data) {
                this.tableData = data;
            },
            handlerRest() {
                this.pageParam.params = {
                    "balanceId": this.id,
                    "endTime": "",
                    "orderSn": "",
                    "payType": "44",
                    "startTime": "",
                    "userId": this.userId
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs['cardRechargePage'].pageNum = 1
                this.pageParam.freshCtrl++;
            },
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
		/*width: 0;宽度为0隐藏*/
		width: 0 !important;
		height: 0 !important;
	}
	/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
		height: 100% !important;
	}
    /deep/ .companySelect{
        .a-ml-20{
            margin-left: 10px !important;
        }
    }
</style>